            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">      
                <b-form  inline style="margin-bottom:15px" novalidate> 
                  <b-nav style="width:100%" class="tabs-sw" tabs>
                    <b-nav-item :active="active===0" @click="active=0;"  class="d-none d-md-block">Individual</b-nav-item>
                    <b-nav-item :active="active===1" @click="active=1;"  class="d-none d-md-block">Grupal</b-nav-item>
                  </b-nav> 
                  <div style=";border:1px solid; border-top:none;border-color: #dee2e6;border-radius: 0 0 3px 3px;width:100%;" class="p-3">
                    <div  v-show="active===0"  style="padding-top:20px;padding-bottom:20px;">
                      <b-row style="width:100%;margin-bottom:20px">
                            <sw-inputs
                              inputTabla="info_aportes"
                              inputCampo="id_list_forma"
                              inline
                              modalVariant="secondary"
                              modalTitle="Agregar forma de pago"
                              modalSize="sm"
                              :md="4" :lg="4">
                              <template v-slot:modal="modalInput">
                                <sw-modallistforma 
                                  @cerrar="modalInput.modalInput.value=false">
                                </sw-modallistforma>
                              </template>
                            </sw-inputs>                               
                            <sw-inputs
                              v-if="dataForm[namePath].info_aportes.id_list_forma===1"
                              inputTabla="info_aportes"
                              inputCampo="id_list_cuentas"
                              inline
                              modalVariant="secondary"
                              modalTitle="Agregar cuenta"
                              modalSize="sm"
                              :md="4" :lg="4">
                              <template v-slot:modal="modalInput">
                                <sw-modallistcuentas
                                  @cerrar="modalInput.modalInput.value=false">
                                </sw-modallistcuentas>
                              </template>
                            </sw-inputs>   
                            <sw-inputs
                              v-if="dataForm[namePath].info_aportes.id_list_forma===1"
                              style="margin-bottom:10px"
                              inputTabla="info_aportes"
                              inputCampo="consignacion"
                              inline
                              :md="4" :lg="4">
                            </sw-inputs>                
                            <sw-inputs
                              inputTabla="info_aportes"
                              inputCampo="descripcion"
                              inline
                              :md="12" :lg="12">
                            </sw-inputs>
                      </b-row>                    
                      <b-row style="width:100%">                                
                        <sw-inputs
                          inputTabla="info_aportes"
                          inputCampo="observacion"
                          :md="12" :lg="12">
                        </sw-inputs>
                      </b-row> 
                    </div>
                    <div v-show="active===1"  style="padding-top:20px;padding-bottom:20px;">
                        <b-row style="width:100%;margin-bottom:20px" v-if="dataForm[namePath].info_aportes.id_list_forma!==1">                      
                          <sw-inputs
                                inputTabla="info_aportes"
                                inputCampo="id_datos_razon"
                                inline
                                :md="4" :lg="4">
                              </sw-inputs>                     
                              <sw-inputs
                                inputTabla="info_aportes"
                                inputCampo="id_list_forma"
                                inline                          
                                modalVariant="secondary"
                                modalTitle="Agregar forma de pago"
                                modalSize="sm"
                                :md="4" :lg="4">
                                <template v-slot:modal="modalInput">
                                  <sw-modallistforma 
                                    @cerrar="modalInput.modalInput.value=false">
                                  </sw-modallistforma>
                                </template>
                              </sw-inputs>                          
                              <sw-inputs
                                style="margin-top: 5px;"
                                inputTabla="info_aportes"
                                inputCampo="label_consecutivo"
                                :showLabel="false"
                                inline
                                :md="4" :lg="4">
                              </sw-inputs>                      
                              <sw-inputs
                                inputTabla="info_aportes"
                                inputCampo="descripcion"
                                inline
                                :md="12" :lg="12">
                              </sw-inputs>
                        </b-row>  
                        <b-row style="width:100%;margin-bottom:20px" v-if="dataForm[namePath].info_aportes.id_list_forma===1">                      
                          <sw-inputs
                                inputTabla="info_aportes"
                                inputCampo="id_datos_razon"
                                inline
                                :md="4" :lg="4">
                              </sw-inputs>                     
                              <sw-inputs
                                inputTabla="info_aportes"
                                inputCampo="id_list_forma"
                                inline
                                modalVariant="secondary"
                                modalTitle="Agregar forma de pago"
                                modalSize="sm"
                                :md="4" :lg="4">
                                <template v-slot:modal="modalInput">
                                  <sw-modallistforma 
                                    @cerrar="modalInput.modalInput.value=false">
                                  </sw-modallistforma>
                                </template>
                              </sw-inputs>                           
                              <sw-inputs
                                style="margin-top: 5px;"
                                inputTabla="info_aportes"
                                inputCampo="label_consecutivo"
                                :showLabel="false"
                                inline
                                :md="4" :lg="4">
                              </sw-inputs>                 
                             
                              <b-col :md="4" :lg="4">
                              </b-col>                                          
                              <sw-inputs
                                inputTabla="info_aportes"
                                inputCampo="id_list_cuentas"
                                inline
                                modalVariant="secondary"
                                modalTitle="Agregar cuenta"
                                modalSize="sm"
                                :md="4" :lg="4">
                                <template v-slot:modal="modalInput">
                                  <sw-modallistcuentas
                                    @cerrar="modalInput.modalInput.value=false">
                                  </sw-modallistcuentas>
                                </template>
                              </sw-inputs>   
                              <b-col :md="4" :lg="4">
                              </b-col>   
                              <b-col :md="4" :lg="4">
                              </b-col>     
                              <sw-inputs
                                style="margin-bottom:10px"
                                inputTabla="info_aportes"
                                inputCampo="consignacion"
                                inline
                                :md="4" :lg="4">
                              </sw-inputs>                
                              <sw-inputs
                                inputTabla="info_aportes"
                                inputCampo="descripcion"
                                inline
                                :md="12" :lg="12">
                              </sw-inputs>
                        </b-row>
                        <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0">
                          <b-col md="6">
                              <span style="font-weight: 500;display:inline-block;width:80px">Contacto:</span> {{dataForm[namePath].info_aportes.name}}<br>
                              <span style="font-weight: 500;display:inline-block;width:80px">Dirección:</span> {{dataForm[namePath].info_aportes.direccion}} <br>
                              <span style="font-weight: 500;display:inline-block;width:80px">Teléfonos:</span> {{dataForm[namePath].info_aportes.telefonos}}<br>
                          </b-col>  
                          <b-col md="6">
                              <span style="font-weight: 500;display:inline-block;width:100px">Documento:</span> {{dataForm[namePath].info_aportes.documento}} <br>     
                              <span style="font-weight: 500;display:inline-block;width:100px">Correo:</span> {{dataForm[namePath].info_aportes.email}} <br>                      
                              <span style="font-weight: 500;display:inline-block;width:100px"> Asesor:</span>  Oficina<br>                        
                          </b-col> 
                        </b-row>  
                        <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0; margin-top:10px">
                          <b-col md="6" style="text-align:justify">
                              <span style="font-weight: 500;display:inline-block;width:80px; ">Concepto:</span> {{dataForm[namePath].info_aportes.descripcion}} {{serviciosDescripcion}} de {{afiliadosAporte.length}} afiliado(s).
                          </b-col>  
                          <b-col md="6">
                              <span style="font-weight: 500;display:inline-block;width:100px">Valor:</span> {{dataForm[namePath].info_aportes.valor}} <br>
                              <b-form-checkbox
                                @input="changeReporte"
                                v-model="reporte"
                                name="checkbox-1"
                                >
                                Solo admin de asesor
                              </b-form-checkbox>
                          </b-col> 
                        </b-row>  
                        <b-row style="width:100%">                                
                          <sw-inputs
                            inputTabla="info_aportes"
                            inputCampo="observacion"
                            :md="12" :lg="12">
                          </sw-inputs>
                        </b-row> 
                    </div> 
                    <h5>Lista de afiliados agrupados</h5>
                    <table  style="margin-bottom:0" class="table table--get table-hover border box-effect linear">
                      <thead>
                        <tr>
                          <th>Documento</th>
                          <th>Nombres</th>
                          <th>Servicios</th>
                          <th>Razón</th>
                          <th>Novedad</th>
                          <th>Dias</th>
                          <th>Valor</th>
                          <th>Quitar</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(items,index) in afiliadosAporte" v-if="items.datos_afiliado" :key="'listadoAportes'+index">
                          <td>{{gettersDatalist('list_documento',items.datos_afiliado.id_list_documento)[0].name}} {{items.datos_afiliado.documento}}</td>
                          <td>{{items.datos_afiliado.name}}</td>
                          <td>{{nameServicios(items.servicios_activos,items.info_afiliacion.id_datos_razon)}}</td>
                          <td>{{gettersDatalist('datos_razon',items.info_afiliacion.id_datos_razon)[0].name}}</td>
                          <td>{{gettersDatalist('list_novedad',items.info_afiliacion.id_list_novedad)[0].name}}</td>
                          <td>{{items.info_afiliacion.dias}}</td>
                          <td>{{preciosServicios([items.servicios_activos,items.info_afiliacion.id_list_novedad])}}</td>
                          <td>     
                            <div style="display:inline-block;padding-left:5px;padding-right:5px">
                              <b-icon  @click="spliceafiliadosAporte(index)"  class="option-btn" icon="trash" scale="1.7" variant="danger"></b-icon>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table> 

                  </div>
                                      
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn=""
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwModallistforma  from '@/components/modals/list_forma.vue'
import SwModallistcuentas  from '@/components/modals/list_cuentas.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import moment from 'moment'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    SwModallistforma,
    SwModallistcuentas  
  },
  props: {
    mesPeriodo: null,
    anoPeriodo: null,
  },
  data()
  {
    return {
      valor: 0,
      reporte: false,
      valorReporte: 0,
      createdCycle: true,
      active: 0,
      serviciosDescripcion: '',      
      claseriesgo: null,
      ibc: {
        Afp: null,
        Ccf: null,
        Eps: null,
        Riesgo: null,
      },
      tarifa:{ 
        Afp: null,
        Eps: null,
        Riesgo: null,
        Ccf: null,
      },
      cotizacion: { 
        Afp: null,
        Eps: null,
        Riesgo: null,
        Ccf: null,
      },
      codigo: {
        Ccf: null,
        Afp: null,
        Eps: null,
      },
      afiliadosAporte: [],
      regAfiliacion: {},
      totalAportes: 0,
      espejoDataPost: []
    }
  },
  async created(){	
    try{
      if(this.namePath==='aportes_registrar')
      {   
          await this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })  
          let await11 = this.resetDataForm({state: 'info_aportes'})
          let await22 = this.resetDataForm({state: 'aportes_registro'})
          let await33 = this.updateDataIndex({ data: 10000})

          let awaitAll = await Promise.all([await11,await22,await33])
          let throwAll = awaitAll.findIndex(list => list === false)
          if(throwAll!==-1)
          {
            throw ('in line 163 at 165')
          }
        

          for (let i = 0; i < this.dataForm[this.namePath].datos_afiliado.length; i++) {
              let filters = this.dataGet[this.namePath].data.filter(list => list.datos_afiliado.id===this.dataForm[this.namePath].datos_afiliado[i].id)
              this.afiliadosAporte.push(filters[0])
              this.valor = this.valor + this.preciosServicios([filters[0].servicios_activos,filters[0].info_afiliacion.id_list_novedad])
          }        
          switch(this.openModal.modal.modal)  
          {
            case 'AportesCentros' : 
              this.regAfiliacion = this.gettersDatalist('datos_contacto',this.afiliadosAporte[0].info_afiliacion.id_datos_contacto)[0]
            break  
            case 'AportesRazon' : 
              this.regAfiliacion = this.gettersDatalist('datos_razon',this.afiliadosAporte[0].info_afiliacion.id_datos_razon)[0]
            break  
            case 'AportesAsesor' : 
              this.regAfiliacion = this.gettersDatalist('datos_asesor',this.afiliadosAporte[0].info_afiliacion.id_datos_asesor)[0]
              this.regAfiliacion.direccion= null
            break  
          }

          const await0 = this.updateDataForm({state: 'info_aportes/valor', data: this.valor}) 
          const await1 = this.updateDataForm({state: 'info_aportes/name', data:  this.regAfiliacion.name}) 
          const await2 = this.updateDataForm({state: 'info_aportes/consecutivo', data:  0}) 
          const await3 = this.updateDataForm({state: 'info_aportes/id_datos_asesor', data:  this.afiliadosAporte[0].info_afiliacion.id_datos_asesor})
          const await4 = this.updateDataForm({state: 'info_aportes/documento', data:  this.regAfiliacion.documento})
          const await5 = this.updateDataForm({state: 'info_aportes/direccion', data:  this.regAfiliacion.direccion})
          const await6 = this.updateDataForm({state: 'info_aportes/telefonos', data:  this.regAfiliacion.telefonos})
          const await7 = this.updateDataForm({state: 'info_aportes/email', data:  this.regAfiliacion.email})  
          const await8 = this.updateDataForm({state: 'info_aportes/id_datos_razon', data:  this.afiliadosAporte[0].info_afiliacion.id_datos_razon})

          awaitAll = await Promise.all([await0,await1,await2,await3,await4, await5, await6, await7, await8])
          throwAll = awaitAll.findIndex(list => list === false)

          if(throwAll!==-1)
          {
            throw ('in line 360 at 368')
          }
          await this.updateGlobal({state:'openModal/modal/loaded',data:true})
      }       
    }catch(e)
    {
      console.log('created in modal aportes grupal',e)
    }
  },
  computed: { 
  },
  async updated()
  {    
    await this.resetDataForm({state: 'info_aportes/descripcion'})
  },
  destroyed()
  {
    this.resetDataForm()
		this.updateDataForm({state: 'base', data: this.buscarIdb({tabla:'base', campo: 'id', value: 1}) })
  },
  methods: {
    spliceafiliadosAporte(index)
    {
      this.afiliadosAporte.splice(index,1)
      this.spliceDataForm({ state: 'datos_afiliado', index: index})
      this.updateCrud({ state: 'tableSave/tableGet2/btn0/'+index+'/check', data: false})
      return true
    },
    async changeReporte()
    {
      if(this.reporte===true && this.dataForm[this.namePath].info_afiliacion.id_datos_asesor!==1)
      {      
        await this.updateDataForm({state: 'info_aportes/valor', data: this.valorReporte})
        return true
      }
      await this.updateDataForm({state: 'info_aportes/valor', data: this.valor})
      return true
    },
    async save(event)
    {
      try {
        await this.updateDataForm({state: 'base', data: await this.buscarIdb({tabla:'base', campo: 'id', value: 1}) }) 
        let nuevoAfiliadosAporte=[]   
        if(this.active===0)
        {
          let mes_periodo=parseInt(this.mesPeriodo)+1
          let ano_periodo=parseInt(this.anoPeriodo)
          for (let i = 0; i < this.afiliadosAporte.length; i++) {
            nuevoAfiliadosAporte[i]={}
            this.ibc= {
              Afp: null,
              Ccf: null,
              Eps: null,
              Riesgo: null,
            },
            this.tarifa={ 
              Afp: null,
              Eps: null,
              Riesgo: null,
              Ccf: null,
            },
            this.cotizacion= { 
              Afp: null,
              Eps: null,
              Riesgo: null,
              Ccf: null,
            },
            this.codigo= {
              Ccf: null,
              Afp: null,
              Eps: null,
            },
            this.totalAportes=0
            let datosdelafiliado = this.gettersDatalist('datos_afiliado',this.afiliadosAporte[i].datos_afiliado.id)[0]        
            nuevoAfiliadosAporte[i].info_aportes=this.deepCopy(this.dataForm[this.namePath].info_aportes)     
            nuevoAfiliadosAporte[i].datos_afiliado=this.deepCopy(this.afiliadosAporte[i].datos_afiliado)     
            nuevoAfiliadosAporte[i].info_afiliacion=this.deepCopy(this.afiliadosAporte[i].info_afiliacion)     
            nuevoAfiliadosAporte[i].aportes_registro=this.deepCopy(this.dataForm[this.namePath].aportes_registro)
            nuevoAfiliadosAporte[i].notas_pendientes=this.deepCopy(this.afiliadosAporte[i].notas_pendientes)

            nuevoAfiliadosAporte[i].info_aportes.documento=datosdelafiliado.documento
            nuevoAfiliadosAporte[i].info_aportes.id_datos_razon=nuevoAfiliadosAporte[i].info_afiliacion.id_datos_razon
            nuevoAfiliadosAporte[i].info_aportes.id_datos_asesor=nuevoAfiliadosAporte[i].info_afiliacion.id_datos_asesor
            nuevoAfiliadosAporte[i].info_aportes.direccion=datosdelafiliado.direccion
            nuevoAfiliadosAporte[i].info_aportes.consecutivo=0
            nuevoAfiliadosAporte[i].info_aportes.email=datosdelafiliado.email
            nuevoAfiliadosAporte[i].info_aportes.name=datosdelafiliado.name
            nuevoAfiliadosAporte[i].info_aportes.id_list_documento=datosdelafiliado.id_list_documento
            nuevoAfiliadosAporte[i].info_aportes.telefonos=datosdelafiliado.telefonos
            nuevoAfiliadosAporte[i].aportes_registro=this.deepCopy(this.dataForm[this.namePath].aportes_registro)
            nuevoAfiliadosAporte[i].info_aportes.fecha=this.fecha().fecha.minHoy
            let diasAportes=nuevoAfiliadosAporte[i].info_afiliacion.dias
            let novedadAportes=nuevoAfiliadosAporte[i].info_afiliacion.id_list_novedad


            if(nuevoAfiliadosAporte[i].info_aportes.id_list_forma===2 || nuevoAfiliadosAporte[i].info_aportes.id_list_forma===5)
            {
                nuevoAfiliadosAporte[i].info_aportes.fecha= null
            }
            
            nuevoAfiliadosAporte[i].info_aportes.id_list_mes= parseInt(this.mesPeriodo)
            nuevoAfiliadosAporte[i].info_aportes.id_list_ano=parseInt( this.anoPeriodo)

            if(mes_periodo===13)
            {
              mes_periodo=1
              ano_periodo=ano_periodo+1
            }           
            
            nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo= mes_periodo
            nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo= ano_periodo

            if(nuevoAfiliadosAporte[i].info_afiliacion.salario>nuevoAfiliadosAporte[i].info_afiliacion.salariobase) {
              nuevoAfiliadosAporte[i].info_afiliacion.salariobase= nuevoAfiliadosAporte[i].info_afiliacion.salario
            } else {
              nuevoAfiliadosAporte[i].info_afiliacion.salario = nuevoAfiliadosAporte[i].info_afiliacion.salariobase
            }

            nuevoAfiliadosAporte[i].aportes_registro.fecha=nuevoAfiliadosAporte[i].info_aportes.fecha
            
            nuevoAfiliadosAporte[i].info_aportes.descripcion= nuevoAfiliadosAporte[i].info_aportes.descripcion+' de '+this.nameServicios(this.afiliadosAporte[i].servicios_activos,this.afiliadosAporte[i].info_afiliacion.id_datos_razon)+' y Administración de '+this.gettersDatalist('list_mes',this.mesPeriodo)[0].name+' del '+this.gettersDatalist('list_ano',this.anoPeriodo)[0].name

            let ingresoPlano=null
            let fechaingresoPlano=null
            if(novedadAportes===1)
            {
              ingresoPlano='X'
              fechaingresoPlano=nuevoAfiliadosAporte[i].info_afiliacion.ingreso
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_novedad= 2
              nuevoAfiliadosAporte[i].info_afiliacion.dias= 30
            }
            let retiroPlano=null
            let fecharetiroPlano=null
            if(novedadAportes===3)
            {
              retiroPlano='X'
              fecharetiroPlano=nuevoAfiliadosAporte[i].info_afiliacion.retiro
              nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo= parseInt(this.mesPeriodo)
              nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo= parseInt(this.anoPeriodo)
              nuevoAfiliadosAporte[i].info_aportes.descripcion= nuevoAfiliadosAporte[i].info_aportes.descripcion+' novedad retiro'

              let anoingreso=moment(nuevoAfiliadosAporte[i].info_afiliacion.ingreso).format('YYYY')
              let mesingreso=moment(nuevoAfiliadosAporte[i].info_afiliacion.ingreso).format('MM')
              let mesretiro=moment(nuevoAfiliadosAporte[i].info_afiliacion.retiro).format('MM')
              let anoretiro=moment(nuevoAfiliadosAporte[i].info_afiliacion.retiro).format('YYYY')
              if(parseInt(anoingreso)===parseInt(anoretiro) && parseInt(mesretiro)===parseInt(mesingreso))
              {
                ingresoPlano='X'
                fechaingresoPlano=nuevoAfiliadosAporte[i].info_afiliacion.ingreso
              }
            }
            let diaspensionPlano=0
            if(novedadAportes===4)
            {
              retiroPlano='P'            
              let mesRetiro = parseInt(this.mesPeriodo) -1 
              let anoRetiro = parseInt(this.anoPeriodo)
              if(mesRetiro===0)
              {
                mesRetiro=12
                anoRetiro=anoRetiro-1
              }
              if(mesRetiro<10)
              {
                mesRetiro='0'+mesRetiro
              }
              fecharetiroPlano=anoRetiro+'-'+mesRetiro+'-30'

              nuevoAfiliadosAporte[i].info_afiliacion.id_list_novedad=2  
              let indexPredeterminado =  _.findIndex(this.predeterminados.configuracion.predeterminados,{'tabla': 'info_afiliacion','campo': 'id_list_subtipo', 'id_list_users': this.user.id})            
              
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_subtipo= indexPredeterminado != -1 ? this.predeterminados.configuracion.predeterminados[indexPredeterminado].predeterminado : 4      
            }
            let exonerado='N'
            if(nuevoAfiliadosAporte[i].info_afiliacion.exonerado===1)
            {
              exonerado='S'
            }
            
            let nuevosActivos=this.deepCopy(this.afiliadosAporte[i].servicios_activos)
            let nuevoValor=0
            for (let j = 0; j < nuevosActivos.length; j++) 
            { 
              if(nuevosActivos[j].name==='Eps' || nuevosActivos[j].name==='Ccf' || nuevosActivos[j].name==='Afp'  )
              {
                let nameLista = await this.gettersDatalist(nuevosActivos[j].name_list,nuevosActivos[j].id_list)[0] 
                this.codigo[nuevosActivos[j].name]=nameLista.codigo
                this.ibc[nuevosActivos[j].name]=parseInt((nuevoAfiliadosAporte[i].info_afiliacion.salario/30)*diasAportes)
                if(nuevosActivos[j].name==='Eps')
                {
                  if(nuevoAfiliadosAporte[i].info_afiliacion.exonerado===1)
                  { 
                    this.tarifa.Eps=this.dataForm[this.namePath].base[0].epsexo
                  }
                  else {
                    this.tarifa.Eps=this.dataForm[this.namePath].base[0].epsnoexo
                  }
                  this.cotizacion.Eps=this.redondeaValue(100,this.ibc.Eps*(this.tarifa.Eps/100),1)+this.ibc.Eps*(this.tarifa.Eps/100)
                  this.totalAportes=this.totalAportes+this.cotizacion.Eps
                }
                
                if(nuevosActivos[j].name==='Afp')
                {                
                  this.tarifa.Afp=this.dataForm[this.namePath].base[0].afp
                  this.cotizacion.Afp=this.redondeaValue(100,this.ibc.Afp*(this.tarifa.Afp/100),1)+this.ibc.Afp*(this.tarifa.Afp/100)
                  this.totalAportes=this.totalAportes+this.cotizacion.Afp
                }

                if(nuevosActivos[j].name==='Ccf')
                {                
                  let razonData= this.gettersDatalist('datos_razon',nuevoAfiliadosAporte[i].info_afiliacion.id_datos_razon)[0]  
                  if(novedadAportes==3 && razonData.retiroparafiscales===1)
                  {
                    if(nuevosActivos[j].iniciolabores===null)
                    {
                      nuevosActivos[j].iniciolabores=nuevoAfiliadosAporte[i].info_afiliacion.ingreso
                    }
                    let fecha1=moment(nuevosActivos[j].iniciolabores)
                    let fecha2=moment(nuevoAfiliadosAporte[i].info_afiliacion.retiro)
                    let dias=fecha2.diff(fecha1,'days')+1
                    if(dias<1) { dias=1;}
                    this.ibc.Ccf=this.ibc.Ccf+parseInt(nuevoAfiliadosAporte[i].info_afiliacion.salariobase*dias/720)
                  }
                  this.tarifa.Ccf=this.dataForm[this.namePath].base[0].ccf
                  this.cotizacion.Ccf=this.redondeaValue(100,this.ibc.Ccf*(this.tarifa.Ccf/100),1)+this.ibc.Ccf*(this.tarifa.Ccf/100)
                  this.totalAportes=this.totalAportes+this.cotizacion.Ccf
                }
              }
              if(nuevosActivos[j].name==='Riesgo')
              {
                let nameLista = await this.gettersDatalist(nuevosActivos[j].name_list,nuevosActivos[j].id_list)[0] 
                this.codigo.Riesgo=nameLista.codigo
                this.ibc.Riesgo=parseInt((nuevoAfiliadosAporte[i].info_afiliacion.salario/30)*diasAportes)
                this.claseriesgo=nuevosActivos[j].id_list
                this.tarifa.Riesgo=this.dataForm[this.namePath].base[0]['r'+nuevosActivos[j].id_list]
                this.cotizacion.Riesgo=this.redondeaValue(100,this.ibc.Riesgo*(this.tarifa.Riesgo/100),1)+this.ibc.Riesgo*(this.tarifa.Riesgo/100)
                this.totalAportes=this.totalAportes+this.cotizacion.Riesgo
              }
              switch(novedadAportes)
              {
                case 1:
                  nuevoValor=nuevoValor+nuevosActivos[j].valoringreso 
                break
                case 2:
                  nuevoValor=nuevoValor+nuevosActivos[j].valor
                break
                case 3: 
                  nuevoValor=nuevoValor+nuevosActivos[j].valorretiro
                break
                case 4: 
                    nuevoValor=nuevoValor+nuevosActivos[j].valor
                break
              }              
            }
            
            let subtipo=this.dataForm[this.namePath].info_afiliacion.id_list_subtipo
            if(this.codigo.Afp!==null)
            {
              subtipo=1
              diaspensionPlano=diasAportes
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_subtipo=1
            }
            else 
            {
              let indexPredeterminado =_.findIndex(this.predeterminados.configuracion.predeterminados,{'tabla': 'info_afiliacion','campo': 'id_list_subtipo', 'id_list_users': this.user.id})
              subtipo= indexPredeterminado!= -1 ? this.predeterminados.configuracion.predeterminados[indexPredeterminado].predeterminado : 4
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_subtipo=subtipo
            }     
            
            nuevoAfiliadosAporte[i].aportes_registro.servicios=this.afiliadosAporte[i].servicios_activos
            if(nuevoAfiliadosAporte[i].info_aportes.id_list_forma===2 || nuevoAfiliadosAporte[i].info_aportes.id_list_forma===5)
            {
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_novedad=novedadAportes 
              nuevoAfiliadosAporte[i].info_afiliacion.dias=diasAportes
              nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo= parseInt(this.mesPeriodo)
              nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo= parseInt(this.anoPeriodo)

              let serviciosAportes_registro=[]
              for (let l = 0; l < nuevoAfiliadosAporte[i].aportes_registro.servicios.length; l++) {
                let nuevoServicioAporte=nuevoAfiliadosAporte[i].aportes_registro.servicios[l]
                nuevoServicioAporte.mes_periodo=parseInt(this.mesPeriodo)
                nuevoServicioAporte.ano_periodo=parseInt(this.anoPeriodo)
                serviciosAportes_registro.push(nuevoServicioAporte);              
              }
              nuevoAfiliadosAporte[i].aportes_registro.servicios=serviciosAportes_registro
            }

            nuevoAfiliadosAporte[i].info_aportes.valor=nuevoValor
            let fechaArchivo=nuevoAfiliadosAporte[i].info_aportes.fecha
            if((nuevoAfiliadosAporte[i].info_aportes.id_list_mes.toString()!==this.fecha().fecha.mesHoy.toString() || nuevoAfiliadosAporte[i].info_aportes.id_list_ano.toString()!==this.fecha().fecha.anoHoy.toString()) && fechaArchivo!==null) 
            {
              fechaArchivo=this.fecha(nuevoAfiliadosAporte[i].info_aportes.id_list_ano+'-'+nuevoAfiliadosAporte[i].info_aportes.id_list_mes+'-01').inicioLabores.servicios
            }
            
            let dataArchivoPlano = { id: null, tipodocumento: this.gettersDatalist('list_documento',nuevoAfiliadosAporte[i].datos_afiliado.id_list_documento)[0].name, documento: nuevoAfiliadosAporte[i].datos_afiliado.documento, nombre1: nuevoAfiliadosAporte[i].datos_afiliado.nombre1, nombre2: nuevoAfiliadosAporte[i].datos_afiliado.nombre2, apellido1: nuevoAfiliadosAporte[i].datos_afiliado.apellido1, apellido2: nuevoAfiliadosAporte[i].datos_afiliado.apellido2, tipo: this.gettersDatalist('list_tipo',nuevoAfiliadosAporte[i].info_afiliacion.id_list_tipo)[0].codigo, subtipo: this.gettersDatalist('list_subtipo',subtipo)[0].codigo, horas: 0, extranjero: null, colextranjero: null, fechaextranjero: null,codigoccf: this.codigo.Ccf, codigoafp: this.codigo.Afp,codigoeps: this.codigo.Eps, diasafp: diaspensionPlano, diaseps: diasAportes, diasriesgo: diasAportes,diasccf: diasAportes, diasparafiscales: null, salario: nuevoAfiliadosAporte[i].info_afiliacion.salario, salariointegral: null, ibcafp: this.ibc.Afp, ibceps: this.ibc.Eps, ibcriesgo: this.ibc.Riesgo, ibcccf: this.ibc.Ccf, ibcparafiscales: null, tarifaafp: this.tarifa.Afp, tarifaaltoriesgo: null, cotizacionafp: this.cotizacion.Afp, voluntariaaportante: null, voluntariaafiliado: null, totalafp: null, solidaridadafp: null, subsistencia: null, retenido: null, tarifaeps: this.tarifa.Eps, cotizacioneps: this.cotizacion.Eps, incapacidadeg: null, valoreg: null, licencia: null, valorlicencia: null, valorupc: null, tarifariesgo: this.tarifa.Riesgo, claseriesgo: this.claseriesgo, centrotrabajo: null, cotizacionriesgo: this.cotizacion.Riesgo, epsdestino: null, afpdestino: null, tarifasena: null, cotizacionsena: null, tarifaicbf: null, cotizacionicbf: null, tarifaccf: this.tarifa.Ccf, cotizacionccf: this.cotizacion.Ccf, tarifaesap: null, cotizacionesap: null, tarifamen: null, cotizacionmen: null, exonerado: exonerado, ingreso: ingresoPlano, fechaingreso: fechaingresoPlano, retiro: retiroPlano, fecharetiro: fecharetiroPlano, tda: null, taa: null, vsp: null, iniciovsp: null, vst: null, sln: null, iniciosln: null, finsln: null, ige: null, inicioige: null, finige: null, lma: null, iniciolma: null, finlma: null, vaclr: null, iniciovaclr: null, finvaclr: null, avp: null, vct: null, iniciovct: null, finvct: null, vip: null, corecciones: null, irl: null, inicioirl: null, finirl: null, fecha: fechaArchivo,servicios: this.archivoServicios(this.afiliadosAporte[i].servicios_activos),aporte: this.totalAportes,dias: diasAportes,planilla:null,fechaplanilla:null,id_list_novedad: novedadAportes,id_list_mes: nuevoAfiliadosAporte[i].info_aportes.id_list_mes, id_list_ano: nuevoAfiliadosAporte[i].info_aportes.id_list_ano,id_datos_afiliado: null,id_info_aportes: null,id_aportes_registro: null,id_info_afiliacion: null,id_datos_razon: null,id_datos_asesor: null,id_datos_contacto: null }

            nuevoAfiliadosAporte[i].archivo_plano=dataArchivoPlano

            nuevoAfiliadosAporte[i].aportes_registro.valor=nuevoAfiliadosAporte[i].info_aportes.valor
            nuevoAfiliadosAporte[i].aportes_registro.fecha=nuevoAfiliadosAporte[i].info_aportes.fecha
            nuevoAfiliadosAporte[i].aportes_registro.mes_periodo=nuevoAfiliadosAporte[i].info_aportes.id_list_mes
            nuevoAfiliadosAporte[i].aportes_registro.ano_periodo=nuevoAfiliadosAporte[i].info_aportes.id_list_ano
            nuevoAfiliadosAporte[i].aportes_registro.id_list_novedad=novedadAportes
            nuevoAfiliadosAporte[i].aportes_registro.reporte=this.totalAportes

            for (let j = 0; j < nuevosActivos.length; j++) {              
              if(nuevosActivos[j].name!=='Traslado')
              {
                if(novedadAportes===3)
                {
                  nuevosActivos[j].mes_periodo=parseInt(this.mesPeriodo)
                  nuevosActivos[j].ano_periodo=parseInt(this.anoPeriodo)
                }
                else 
                {
                  if(novedadAportes!==4)
                  {
                    nuevosActivos[j].mes_periodo=nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo
                    nuevosActivos[j].ano_periodo=nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo 
                  } 
                  else if(nuevosActivos[j].name!=='Afp'){
                    nuevosActivos[j].mes_periodo=nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo
                    nuevosActivos[j].ano_periodo=nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo 
                  }
                  else if(nuevosActivos[j].name==='Afp'){          
                    nuevosActivos[j].mes_periodo=parseInt(this.mesPeriodo)
                    nuevosActivos[j].ano_periodo=parseInt(this.anoPeriodo)        
                    nuevosActivos[j].nota_delete='Retiro solo pensión'
                    nuevosActivos[j].deleted_at=this.fecha().fecha.delete
                  }  
                }
              }
              else 
              {                
                nuevosActivos[j].nota_delete='Se actualiza la eps con la del traslado'
                nuevosActivos[j].deleted_at=this.fecha().fecha.delete
              }
            }
            nuevoAfiliadosAporte[i].servicios_activos=nuevosActivos              
          }
        }
        if(this.active===1)
        {
          let mes_periodo=parseInt(this.mesPeriodo)+1
          let ano_periodo=parseInt(this.anoPeriodo)
          if(mes_periodo==13)
          {
            mes_periodo=1
            ano_periodo=ano_periodo+1
          }
          this.afiliadosAporte.splice(0,0,{info_aportes: this.dataForm[this.namePath].info_aportes})
          let totalafiliadosAporte=parseInt(this.afiliadosAporte.length)-1
          this.afiliadosAporte[0].info_aportes.id_list_mes= parseInt(this.mesPeriodo)
          this.afiliadosAporte[0].info_aportes.id_list_ano= parseInt(this.anoPeriodo)
          this.afiliadosAporte[0].info_aportes.tipo= 1
          this.afiliadosAporte[0].info_aportes.descripcion= this.afiliadosAporte[0].info_aportes.descripcion+' de '+totalafiliadosAporte+' Afiliados mes de '+this.gettersDatalist('list_mes',this.mesPeriodo)[0].name+' del '+this.gettersDatalist('list_ano',this.anoPeriodo)[0].name
          this.afiliadosAporte[0].info_aportes.fecha=this.fecha().fecha.minHoy

          if(this.afiliadosAporte[0].info_aportes.id_list_forma===2 || this.afiliadosAporte[0].info_aportes.id_list_forma===5)
          {
              this.afiliadosAporte[0].info_aportes.fecha= null
          }

          nuevoAfiliadosAporte[0]=this.afiliadosAporte[0]
          for (let i = 1; i < this.afiliadosAporte.length; i++) {  
            nuevoAfiliadosAporte[i]={}           
            nuevoAfiliadosAporte[i].datos_afiliado=this.deepCopy(this.afiliadosAporte[i].datos_afiliado)     
            nuevoAfiliadosAporte[i].info_afiliacion=this.deepCopy(this.afiliadosAporte[i].info_afiliacion)     
            nuevoAfiliadosAporte[i].aportes_registro=this.deepCopy(this.dataForm[this.namePath].aportes_registro)
            nuevoAfiliadosAporte[i].notas_pendientes=this.deepCopy(this.afiliadosAporte[i].notas_pendientes)
            this.ibc= {
              Afp: null,
              Ccf: null,
              Eps: null,
              Riesgo: null,
            },
            this.tarifa={ 
              Afp: null,
              Eps: null,
              Riesgo: null,
              Ccf: null,
            },
            this.cotizacion= { 
              Afp: null,
              Eps: null,
              Riesgo: null,
              Ccf: null,
            },
            this.codigo= {
              Ccf: null,
              Afp: null,
              Eps: null,
            },
            this.totalAportes=0

            let diasAportes=nuevoAfiliadosAporte[i].info_afiliacion.dias
            let novedadAportes=nuevoAfiliadosAporte[i].info_afiliacion.id_list_novedad
            nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo=mes_periodo
            nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo=ano_periodo

            if(nuevoAfiliadosAporte[i].info_afiliacion.salario>nuevoAfiliadosAporte[i].info_afiliacion.salariobase) {
              nuevoAfiliadosAporte[i].info_afiliacion.salariobase= nuevoAfiliadosAporte[i].info_afiliacion.salario
            } else {
              nuevoAfiliadosAporte[i].info_afiliacion.salario = nuevoAfiliadosAporte[i].info_afiliacion.salariobase
            }

            nuevoAfiliadosAporte[i].aportes_registro.fecha=this.afiliadosAporte[0].info_aportes.fecha
            
            let ingresoPlano=null
            let fechaingresoPlano=null
            if(novedadAportes===1)
            {
              ingresoPlano='X'
              fechaingresoPlano=nuevoAfiliadosAporte[i].info_afiliacion.ingreso
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_novedad= 2
              nuevoAfiliadosAporte[i].info_afiliacion.dias= 30
              nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo=mes_periodo
              nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo=ano_periodo
            }
            let retiroPlano=null
            let fecharetiroPlano=null
            if(novedadAportes===3)
            {
              retiroPlano='X'
              fecharetiroPlano=nuevoAfiliadosAporte[i].info_afiliacion.retiro
              nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo= parseInt(this.mesPeriodo)
              nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo= parseInt(this.anoPeriodo)

              let anoingreso=moment(nuevoAfiliadosAporte[i].info_afiliacion.ingreso).format('YYYY')
              let mesingreso=moment(nuevoAfiliadosAporte[i].info_afiliacion.ingreso).format('MM')
              let mesretiro=moment(nuevoAfiliadosAporte[i].info_afiliacion.retiro).format('MM')
              let anoretiro=moment(nuevoAfiliadosAporte[i].info_afiliacion.retiro).format('YYYY')
              if(parseInt(anoingreso)===parseInt(anoretiro) && parseInt(mesretiro)===parseInt(mesingreso))
              {
                ingresoPlano='X'
                fechaingresoPlano=nuevoAfiliadosAporte[i].info_afiliacion.ingreso
              }
            }

            let diaspensionPlano=0
            if(novedadAportes===4)
            {
              retiroPlano='P'            
              let mesRetiro = parseInt(this.mesPeriodo) -1 
              let anoRetiro = parseInt(this.anoPeriodo) 
              if(mesRetiro===0)
              {
                mesRetiro=12
                anoRetiro=anoRetiro-1
              }
              if(mesRetiro<10)
              {
                mesRetiro='0'+mesRetiro
              }
              fecharetiroPlano=anoRetiro+'-'+mesRetiro+'-30'

              nuevoAfiliadosAporte[i].info_afiliacion.id_list_novedad=2  
              let indexPredeterminado =  _.findIndex(this.predeterminados.configuracion.predeterminados,{'tabla': 'info_afiliacion','campo': 'id_list_subtipo', 'id_list_users': 1})            
              
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_subtipo= indexPredeterminado != -1 ? this.predeterminados.configuracion.predeterminados[indexPredeterminado].predeterminado : 4       
            }       
            
            let exonerado='N'
            if(nuevoAfiliadosAporte[i].info_afiliacion.exonerado===1)
            {
              exonerado='S'
            }            
          
            let nuevosActivos=this.deepCopy(this.afiliadosAporte[i].servicios_activos)
            
            for (let j = 0; j < nuevosActivos.length; j++) 
            { 
              if(nuevosActivos[j].name==='Eps' || nuevosActivos[j].name==='Ccf' || nuevosActivos[j].name==='Afp'  )
              {
                let nameLista = await this.gettersDatalist(nuevosActivos[j].name_list,nuevosActivos[j].id_list)[0] 
                this.codigo[nuevosActivos[j].name]=nameLista.codigo
                this.ibc[nuevosActivos[j].name]=parseInt((nuevoAfiliadosAporte[i].info_afiliacion.salario/30)*diasAportes)
                if(nuevosActivos[j].name==='Eps')
                {
                  if(nuevoAfiliadosAporte[i].info_afiliacion.exonerado===1)
                  { 
                    this.tarifa.Eps=this.dataForm[this.namePath].base[0].epsexo
                  }
                  else {
                    this.tarifa.Eps=this.dataForm[this.namePath].base[0].epsnoexo
                  }
                  this.cotizacion.Eps=this.redondeaValue(100,this.ibc.Eps*(this.tarifa.Eps/100),1)+this.ibc.Eps*(this.tarifa.Eps/100)
                  this.totalAportes=this.totalAportes+this.cotizacion.Eps
                }
                
                if(nuevosActivos[j].name==='Afp')
                {                
                  this.tarifa.Afp=this.dataForm[this.namePath].base[0].afp
                  this.cotizacion.Afp=this.redondeaValue(100,this.ibc.Afp*(this.tarifa.Afp/100),1)+this.ibc.Afp*(this.tarifa.Afp/100)
                  this.totalAportes=this.totalAportes+this.cotizacion.Afp
                }

                if(nuevosActivos[j].name==='Ccf')
                {              
                  let razonData= this.gettersDatalist('datos_razon',nuevoAfiliadosAporte[i].info_afiliacion.id_datos_razon)[0]  
                  if(novedadAportes===3 && razonData.retiroparafiscales===1)
                  {
                    if(nuevosActivos[j].iniciolabores===null)
                    {
                      nuevosActivos[j].iniciolabores=nuevoAfiliadosAporte[i].info_afiliacion.ingreso
                    }
                    
                    let fecha1=moment(nuevosActivos[j].iniciolabores)
                    let fecha2=moment(nuevoAfiliadosAporte[i].info_afiliacion.retiro)
                    let dias=fecha2.diff(fecha1,'days')+1
                    if(dias<1) { dias=1;}
                    
                    this.ibc.Ccf=this.ibc.Ccf+parseInt(nuevoAfiliadosAporte[i].info_afiliacion.salario*dias/720)
                  }
                  this.tarifa.Ccf=this.dataForm[this.namePath].base[0].ccf
                  this.cotizacion.Ccf=this.redondeaValue(100,this.ibc.Ccf*(this.tarifa.Ccf/100),1)+this.ibc.Ccf*(this.tarifa.Ccf/100)
                  this.totalAportes=this.totalAportes+this.cotizacion.Ccf
                }
              }
              if(nuevosActivos[j].name==='Riesgo')
              {
                let nameLista = await this.gettersDatalist(nuevosActivos[j].name_list,nuevosActivos[j].id_list)[0] 
                this.codigo.Riesgo=nameLista.codigo
                this.ibc.Riesgo=parseInt((nuevoAfiliadosAporte[i].info_afiliacion.salario/30)*diasAportes)
                this.claseriesgo=nuevosActivos[j].id_list
                this.tarifa.Riesgo=this.dataForm[this.namePath].base[0]['r'+nuevosActivos[j].id_list]
                this.cotizacion.Riesgo=this.redondeaValue(100,this.ibc.Riesgo*(this.tarifa.Riesgo/100),1)+this.ibc.Riesgo*(this.tarifa.Riesgo/100)
                this.totalAportes=this.totalAportes+this.cotizacion.Riesgo
              }
            }
            
            let subtipo=this.dataForm[this.namePath].info_afiliacion.id_list_subtipo
            if(this.codigo.Afp!==null)
            {
              subtipo=1
              diaspensionPlano=diasAportes
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_subtipo=1
            }
            else 
            {
              let indexPredeterminado =_.findIndex(this.predeterminados.configuracion.predeterminados,{'tabla': 'info_afiliacion','campo': 'id_list_subtipo', 'id_list_users': 1})
              subtipo= indexPredeterminado!= -1 ?this.predeterminados.configuracion.predeterminados[indexPredeterminado].predeterminado : 4
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_subtipo=subtipo
            }

             // reviso si es credito o mensajeria
            nuevoAfiliadosAporte[i].aportes_registro.servicios=this.afiliadosAporte[i].servicios_activos
            if(this.afiliadosAporte[0].info_aportes.id_list_forma===2 || this.afiliadosAporte[0].info_aportes.id_list_forma===5)
            {
              nuevoAfiliadosAporte[i].info_afiliacion.id_list_novedad=novedadAportes  
              nuevoAfiliadosAporte[i].info_afiliacion.dias=diasAportes  
              nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo= parseInt(this.mesPeriodo)
              nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo= parseInt(this.anoPeriodo)

              let serviciosAportes_registro=[]
              for (let l = 0; l < nuevoAfiliadosAporte[i].aportes_registro.servicios.length; l++) {
                let nuevoServicioAporte=nuevoAfiliadosAporte[i].aportes_registro.servicios[l]
                nuevoServicioAporte.mes_periodo=parseInt(this.mesPeriodo)
                nuevoServicioAporte.ano_periodo=parseInt(this.anoPeriodo)
                serviciosAportes_registro.push(nuevoServicioAporte);              
              }
              nuevoAfiliadosAporte[i].aportes_registro.servicios=serviciosAportes_registro

            }
            
            let fechaArchivo=this.afiliadosAporte[0].info_aportes.fecha
            if((this.afiliadosAporte[0].info_aportes.id_list_mes.toString()!==this.fecha().fecha.mesHoy.toString() || this.afiliadosAporte[0].info_aportes.id_list_ano.toString()!==this.fecha().fecha.anoHoy.toString()) && fechaArchivo!==null) 
            {
              fechaArchivo=this.fecha(this.afiliadosAporte[0].info_aportes.id_list_ano+'-'+this.afiliadosAporte[0].info_aportes.id_list_mes+'-01').inicioLabores.servicios
            }

            let dataArchivoPlano = { id: null, tipodocumento: this.gettersDatalist('list_documento',nuevoAfiliadosAporte[i].datos_afiliado.id_list_documento)[0].name, documento: nuevoAfiliadosAporte[i].datos_afiliado.documento, nombre1: nuevoAfiliadosAporte[i].datos_afiliado.nombre1, nombre2: nuevoAfiliadosAporte[i].datos_afiliado.nombre2, apellido1: nuevoAfiliadosAporte[i].datos_afiliado.apellido1, apellido2: nuevoAfiliadosAporte[i].datos_afiliado.apellido2, tipo: this.gettersDatalist('list_tipo',nuevoAfiliadosAporte[i].info_afiliacion.id_list_tipo)[0].codigo, subtipo: this.gettersDatalist('list_subtipo',subtipo)[0].codigo, horas: 0, extranjero: null, colextranjero: null, fechaextranjero: null,codigoccf: this.codigo.Ccf, codigoafp: this.codigo.Afp,codigoeps: this.codigo.Eps, diasafp: diaspensionPlano, diaseps: diasAportes, diasriesgo: diasAportes,diasccf: diasAportes, diasparafiscales: null, salario: nuevoAfiliadosAporte[i].info_afiliacion.salario, salariointegral: null, ibcafp: this.ibc.Afp, ibceps: this.ibc.Eps, ibcriesgo: this.ibc.Riesgo, ibcccf: this.ibc.Ccf, ibcparafiscales: null, tarifaafp: this.tarifa.Afp, tarifaaltoriesgo: null, cotizacionafp: this.cotizacion.Afp, voluntariaaportante: null, voluntariaafiliado: null, totalafp: null, solidaridadafp: null, subsistencia: null, retenido: null, tarifaeps: this.tarifa.Eps, cotizacioneps: this.cotizacion.Eps, incapacidadeg: null, valoreg: null, licencia: null, valorlicencia: null, valorupc: null, tarifariesgo: this.tarifa.Riesgo, claseriesgo: this.claseriesgo, centrotrabajo: null, cotizacionriesgo: this.cotizacion.Riesgo, epsdestino: null, afpdestino: null, tarifasena: null, cotizacionsena: null, tarifaicbf: null, cotizacionicbf: null, tarifaccf: this.tarifa.Ccf, cotizacionccf: this.cotizacion.Ccf, tarifaesap: null, cotizacionesap: null, tarifamen: null, cotizacionmen: null, exonerado: exonerado, ingreso: ingresoPlano, fechaingreso: fechaingresoPlano, retiro: retiroPlano, fecharetiro: fecharetiroPlano, tda: null, taa: null, vsp: null, iniciovsp: null, vst: null, sln: null, iniciosln: null, finsln: null, ige: null, inicioige: null, finige: null, lma: null, iniciolma: null, finlma: null, vaclr: null, iniciovaclr: null, finvaclr: null, avp: null, vct: null, iniciovct: null, finvct: null, vip: null, corecciones: null, irl: null, inicioirl: null, finirl: null, fecha: fechaArchivo,servicios: this.archivoServicios(this.afiliadosAporte[i].servicios_activos),aporte: this.totalAportes,dias: diasAportes,planilla:null,fechaplanilla:null,id_list_novedad: novedadAportes,id_list_mes: this.afiliadosAporte[0].info_aportes.id_list_mes, id_list_ano: this.afiliadosAporte[0].info_aportes.id_list_ano,id_datos_afiliado: null,id_info_aportes: null,id_aportes_registro: null,id_info_afiliacion: null,id_datos_razon: null,id_datos_asesor: null,id_datos_contacto: null }

            nuevoAfiliadosAporte[i].archivo_plano=dataArchivoPlano

            nuevoAfiliadosAporte[i].aportes_registro.valor=this.preciosServicios([this.afiliadosAporte[i].servicios_activos,novedadAportes])
            nuevoAfiliadosAporte[i].aportes_registro.fecha=this.afiliadosAporte[0].info_aportes.fecha
            nuevoAfiliadosAporte[i].aportes_registro.mes_periodo=this.afiliadosAporte[0].info_aportes.id_list_mes
            nuevoAfiliadosAporte[i].aportes_registro.id_list_novedad=novedadAportes
            nuevoAfiliadosAporte[i].aportes_registro.ano_periodo=this.afiliadosAporte[0].info_aportes.id_list_ano
            nuevoAfiliadosAporte[i].aportes_registro.reporte=this.totalAportes

            for (let j = 0; j < nuevosActivos.length; j++) {                          
              if(nuevosActivos[j].name!=='Traslado')
              {
                if(novedadAportes===3)
                {
                  nuevosActivos[j].mes_periodo=parseInt(this.mesPeriodo)
                  nuevosActivos[j].ano_periodo=parseInt(this.anoPeriodo)
                }
                else 
                {
                  if(novedadAportes!==4)
                  {
                    nuevosActivos[j].mes_periodo=nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo
                    nuevosActivos[j].ano_periodo=nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo 
                  } 
                  else if(nuevosActivos[j].name!=='Afp'){
                    nuevosActivos[j].mes_periodo=nuevoAfiliadosAporte[i].info_afiliacion.mes_periodo
                    nuevosActivos[j].ano_periodo=nuevoAfiliadosAporte[i].info_afiliacion.ano_periodo 
                  }
                  else if(nuevosActivos[j].name==='Afp'){          
                    nuevosActivos[j].mes_periodo=parseInt(this.mesPeriodo)
                    nuevosActivos[j].ano_periodo=parseInt(this.anoPeriodo)        
                    nuevosActivos[j].nota_delete='Retiro solo pensión'
                    nuevosActivos[j].deleted_at=this.fecha().fecha.delete
                  }
                }
              }
              else 
              {                
                nuevosActivos[j].nota_delete='Se actualiza la eps con la del traslado'
                nuevosActivos[j].deleted_at=this.fecha().fecha.delete
              }
            }
            nuevoAfiliadosAporte[i].servicios_activos=nuevosActivos      
          }        
        }
        await this.updateDataPost({state: 'data', data: nuevoAfiliadosAporte}) 
        this.$emit('save',{save: false, ftn: 'aportesGrupalFtn' })

      }catch(e)
      {
        console.log(e)
      }
    },
    nameServicios(value,razon){ 
      let name=''
      for(let i=0;i<value.length;i++)
      { 
        if(value[i].name!='Administración')
        {
          if(value[i].name==='Riesgo')
          {
            let datos_razon=this.gettersDatalist('datos_razon',razon)[0]
            name=name+' ARL '+this.gettersDatalist('list_arl',datos_razon.id_list_arl)[0].name+' '
          }
          name=name+' '+value[i].name
          if(value[i].name_list!==null && value[i].name_list!=='')
          {
            name=name+' '+this.gettersDatalist(value[i].name_list,value[i].id_list)[0].name+' '
          }
        }
      } 
      return name
    },
    archivoServicios(value){ 
      let name=''
      for(let i=0;i<value.length;i++)
      { 
        if(value[i].name==='Eps' || value[i].name==='Riesgo' || value[i].name==='Ccf' || value[i].name==='Afp')
        {
          name=name+' '+value[i].name
          if(value[i].name_list!==null && value[i].name_list!=='')
          {
            name=name+' '+this.gettersDatalist(value[i].name_list,value[i].id_list)[0].name+' '
          }
        }
      } 
      return name
    },
    preciosServicios(value)
    {
     let valor=0	
      for (let i = 0; i < value[0].length; i++) {
        switch(value[1])
        {
          case 1: 
            valor= valor+value[0][i].valoringreso
          break
          case 2: 
            valor= valor+value[0][i].valor
          break
          case 3: 
            valor= valor+value[0][i].valorretiro
          break
          case 4: 
            valor= valor+value[0][i].valor
          break
        }
      }
      
      return valor
    }
  }
}
</script>
<style>
.tabs-sw{
    padding-left: 10px;
    width: 100%;
    padding-top: 12px;
    border-radius: 3px 3px 0 0;
    border: 1px solid #dee2e6;
    background-color: rgba(0,0,0,.03);
}
.tabs-sw .nav-link.active{
  background:white;
} 
</style>